export default "__VITE_ASSET__86d9e1b1__"